import { render, staticRenderFns } from "./MaskView.vue?vue&type=template&id=4472073a&scoped=true"
import script from "./MaskView.vue?vue&type=script&lang=js"
export * from "./MaskView.vue?vue&type=script&lang=js"
import style0 from "./MaskView.vue?vue&type=style&index=0&id=4472073a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4472073a",
  null
  
)

export default component.exports